// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { getChildrenPosition } from '../utils/misc';
/**
 * @hidden
 */

export var downArrowClass = 'k-i-arrow-60-down';
/**
 * @hidden
 */

export var rightArrowClass = 'k-i-arrow-60-right';
/**
 * @hidden
 */

export var leftArrowClass = 'k-i-arrow-60-left'; // tslint:enable:max-line-length

var MenuItemArrowVue2 = {
  name: 'KendoMenuItemArrow',
  props: {
    itemId: String,
    dir: String,
    verticalMenu: Boolean
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  render: function render(createElement) {
    var h = gh || createElement;
    return h("span", {
      "class": "k-menu-expand-arrow"
    }, [h("span", {
      "class": this.getArrowClassName(),
      role: "presentation",
      attrs: this.v3 ? undefined : {
        role: "presentation"
      }
    })]);
  },
  methods: {
    getArrowClassName: function getArrowClassName() {
      var _a;

      var childrenPosition = getChildrenPosition(this.$props.itemId, this.$props.verticalMenu === true, this.$props.dir === 'rtl');
      return _a = {
        'k-icon': true
      }, _a[downArrowClass] = childrenPosition === 'downward', _a[rightArrowClass] = childrenPosition === 'rightward', _a[leftArrowClass] = childrenPosition === 'leftward', _a;
    }
  }
};
var MenuItemArrow = MenuItemArrowVue2;
export { MenuItemArrow, MenuItemArrowVue2 };